




















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import vSelect from "vue-select";
import order from "@/components/posts/PostTypeOrder";

@Component({
    components: {
        vSelect
    }
})
export default class ChannelAddPostModal extends Vue {
    @Prop() allowedPostTypes!: string[];
    @Prop() channelId!: string;
    @Prop() isEditor!: boolean;

    get postTypes() {
        return this.allowedPostTypes.sort((a, b) => order.indexOf(a) - order.indexOf(b));
    }

    // methods
    open() {
        this.$bvModal.show("modal-addPost");
    }

    selectPostType(postType: string) {
        if (postType.toLocaleLowerCase() === "html") {
            this.$emit("openCustomItemModal", this.channelId, postType);
            return;
        }

        if (postType.toLowerCase() === "fixedhtml") {
            this.$emit("openHtmlItemModal", this.channelId, postType);
            return;
        }

        if (this.isEditor) {
            this.$router.push({
                name: "editorCreatePost",
                params: {
                    channelId: this.channelId,
                    postType: postType
                }
            });
        } else {
            this.$router.push({
                name: "createPost",
                params: {
                    channelId: this.channelId,
                    postType: postType
                }
            });
        }
    }
}
